const pagesLaborCoreOperationPackagesEn = {
  assignTaskToPerson: {
    anchorDate: 'Anchor date',
    assignSuccess: 'Operation package started successfully',
    assignSuccessMessage: '{{count}} people assigned',
    inputTagName: 'Enter tag name',
    inputTagNameDescription:
      'Set a tag name to label multiple procedures started at the same time.',
    selectPackage: 'Select operation package',
    selectPackageDescription: 'Select the operation package you want to start',
    selectPackagePattern: 'Select operation package pattern',
    selectPackagePatternDescription:
      'Select the operation package pattern you want to start',
    selectPerson: 'Select target',
    selectPersonDescription: 'Select the target to assign',
    selectPersonPlaceholder: 'Select target',
    selectedOperationPackage: 'Selected operation package',
    selectedOperationPattern: 'Selected operation package pattern',
    selectedPerson: 'Selected target',
    startOperationTask: 'Start operation package',
    startOperationTaskDescription:
      'Start the operation task by selecting the operation package and pattern, and then assigning the target.',
    tagName: 'Tag name',
    tagNamePlaceholder: 'e.g. May 2026 batch',
    validationErrors: {
      noPersonSelected: 'Please select at least one person to assign',
      pastDateWithNewPerson: 'Choose the future dates when adding new people',
    },
  },
  displayDataAggregate: 'View: Data summary',
  filterByPerson: 'Filter by person',
  laborCore: 'Labor Core',
  patternEmptyState: {
    description:
      'No operation package pattern found. Please register from the Add pattern button above.',
    title: 'No operation package pattern',
  },
  sideTab: {
    demoItems: {
      bankAccountChange: 'Bank account update',
      certificate: 'Certificate reque',
      commuteRouteChange: 'Commute route update',
      companyHousing: 'Company housing application',
      condolence: 'Celebratory/Condolatory occasion procedures',
      contactChange: 'Contact info update',
      contractRenewal: 'Labor contract renewal',
      divorce: 'Divorce procedures',
      eGovernment: 'e-Gov applications',
      elderlyEmployment: 'Elderly employment continuation benefit application',
      employmentTypeChange: 'Employment type change application',
      healthManagement: 'Health management',
      license: 'License and qualification procedures',
      marriage: 'Marriage procedures',
      myNumber: 'My Number collection procedure',
      overtimeMeasures: 'Overwork measures',
      remoteWork: 'Remote work management',
      transfer: 'Transfer procedures for office transfers',
      yearEndAdjustment: 'Year-end tax adjustment',
    },
    underDevelopment: 'This operation package is currently under development.',
  },
  startNew: 'Start new',
  status: {
    approval: 'Approval',
    approvalRequired: 'Approval Required',
    attachment: 'Attachment',
    completed: 'Completed',
    notRequired: 'Not Required',
    todo: 'Not Started',
  },
  tabs: {
    archive: 'Archive',
    config: 'Config',
    operationPackages: 'Operation packages',
    settings: 'Settings',
  },
  taskEmptyState: {
    description: 'Initiate from the start new button above.',
    title: 'No Operation task',
  },
};

export default pagesLaborCoreOperationPackagesEn;
